<template>
  <div class="pc_detail">
    <!-- 背景 -->
    <div>
      <div class="bgd">
        <img src="@/assets/bgs.svg" />
      </div>
      <div class="titled">
        <img src="@/assets/logo1.svg" />
      </div>
    </div>
    <!-- 主体 -->
    <div class="maind">
      <!-- 顶部导航 -->
      <div class="topbar" v-if="breadcrumbData.length > 0">
        <Breadcrumb class="breadcrumb" :breadcrumbData="breadcrumbData" />
        <div class="goBack" @click="returnObj()">
          <img class="goBackIcon" src="@/assets/return.svg" />
          <div class="goBackText">返回</div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="articled">
        <!-- 标题 -->
        <div class="articledTitle">{{ detailMSG.BusinessName }}</div>
        <!-- 内容 -->
        <div class="articledContent" v-html="detailMSG.BusinessContent"></div>
        <!-- 附件 -->
        <div class="articledAppend" v-show="showAppendBox">
          <div v-show="showAppend">
            <div class="articledBoxTitle">相关附件</div>
            <div class="articledAppendBox">
              <div
                class="articledBoxTxt"
                :key="item"
                v-for="item in attachment1"
                @click="download(item.AttachmentFileName)"
              >
                {{ item.AttachmentName }}
              </div>
            </div>
          </div>
          <div v-show="showChart">
            <div class="articledBoxTitle">相关表格</div>

            <div class="articledAppendBox">
              <div
                class="articledBoxTxt"
                :key="item"
                v-for="item in attachment2"
                @click="download(item.AttachmentFileName)"
              >
                {{ item.AttachmentName }}
              </div>
            </div>
          </div>
        </div>
        <!-- 科室信息 -->
        <div class="articledFooter">
          <div class="articledFooterTxt">
            主管科室：{{ detailMSG.DepartName }}
          </div>
          <div class="articledFooterTxt">|</div>
          <div class="articledFooterTxt">
            联系电话：{{ detailMSG.ContactPhone }}
          </div>
        </div>
        <!-- 返回 -->
        <div class="articledReturn" @click="returnObj()">
          <img src="@/assets/return.svg" />
          <div>点击返回上一级</div>
        </div>
      </div>
     
    </div>
    <div class="bottomd" :style="elementStyle">版权所有 © 2021 河南大学教务处</div>
  </div>
</template>



<style scoped>
.pc_detail {
  width: 100%;
  height: 100%;
  background: #f6f9ff;
}

.bgd {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: auto;
}
.bgd img {
  width: 100%;
  height: auto;
}
.titled {
  position: absolute;
  left: 20%;
  top: 35px;
  width: 489px;
  height: 50px;
}

.maind {
  width: 1920px;
  height: auto;
  background: #f6f9ff;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  left: 20%;
  top: 120px;
  width: 60%;
  height: 72px;
  background: #f6f9ff;
  border-radius: 8px 8px 8px 8px;
}

.breadcrumb {
  margin-left: 2.22%;
}

.goBack {
  margin-right: 3.7%;
  display: flex;
  align-items: center;
}

.goBack div {
  width: 32px;
  height: 48px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #00589f;
  line-height: 48px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.goBack img {
  margin-right: 4px;
}

.goBack:hover {
  cursor: pointer;
}

.articled {
  margin-bottom: 137px;
  position: absolute;
  left: 20%;
  top: 200px;
  width: 60%;
  height: 75vh;
  overflow-y: auto; /* 启用垂直滚动条 */
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
}
/* Optional: 自定义滚动条样式 */
.articled::-webkit-scrollbar {
  width: 3px;
}

.articled::-webkit-scrollbar-thumb {
  background-color: #00589F; /* 滚动条的颜色 */
  border-radius: 10px;
}
.articled .articledTitle {
  margin: 32px auto; /* 左右自动边距，居中 */
  
  font-weight: 500;
  font-size: 24px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.articled .articledContent {
  margin: 8px 164px auto 100px;
  box-sizing: border-box;
  overflow: auto;
  text-align: left;
}
.articledContent p {
  float: left;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 48px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.articledAppend {
  text-align: left;
  margin-top: 40px;
  margin-left: 100px;
}
.articledBoxTitle {
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.articledAppendBox {
  margin-top: 16px;
  margin-bottom: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 32px;
  background: #f6f9ff;
  margin-right: 100px;
  border-radius: 8px 8px 8px 8px;
}
.articledBoxTxt {
  height: 40px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #00589f;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
/* 返回按钮 */
.goBack:hover {
  cursor: pointer;
}

/* 附件列表 */
.articledBoxTxt:hover {
  cursor: pointer;
}

/* 点击返回上一级 */
.articledReturn:hover {
  cursor: pointer;
}

.articledFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 180px;
  margin: 6px 100px 10px 100px;
  background: linear-gradient(180deg, #edf7ff 0%, #e4f3ff 100%);
  border-radius: 4px 4px 0px 0px;
}
.articledFooterTxt {
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.articledReturn {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.articledReturn div {
  margin-left: 4px;
  font-weight: 400;
  font-size: 16px;
  color: #00589f;
  line-height: 48px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.bottomd {
  
  position: absolute;
  top: 95%;
  left: 0;
  margin-top: 10px;
  width: 209px;
  height: 21px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { searchArticle } from "../../utils/api.js";
import axios from "axios";
export default {
  components: {
    Breadcrumb,
  },
  name: "pc_detail",
  mounted: function () {
    console.log("进入页面");
    console.log(this.$route.params);
    this.objId = this.$route.params.role;
    this.articleNum = this.$route.params.articleID;
    this.searchCTN = this.$route.params.searchCTN;
    this.haveArticleCTN(this.articleNum);
    this.updateElementPosition(); // 初始化设置
    window.addEventListener('resize', this.updateElementPosition); // 监听窗口大小变化
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.updateElementPosition); // 清理事件监听器
  },
  data() {
    return {
      //判断是否是从搜索进来的
      ifInSearch: false,
      //对象ID
      objId: -1,
      //文章ID
      articleNum: -1,
      //动态增加属性
      dynamicClass: -1,
      //显示附件
      showAppend: false,
      //显示表格
      showChart: false,
      //显示保存附件表格的大盒子
      showAppendBox: true,
      //下载地址
      theHref: "",
      // content: "请在此编辑您需要发布的内容",
      // editorOption: {},
      showContent: -1,
      breadcrumbData: [],
      elementStyle: {
        top:'1027px',
        bottom:'',
        left:'0',
        position: 'absolute',
        width: '100%',

        height: '21px',
        fontWeight: 400,
        fontSize: '14px',
        color: '#666666',
        lineHeight: '21px',
        textAlign: 'center',
        fontStyle: 'normal',
        textTransform: 'none',
      },
      breadcrumbDataAll: [
        {
          key: "首页",
          path: "./pc_home",
          name: "pc_home",
          params: {},
          icon: "/home.svg",
        },
        {
          key: "学生",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 10 },
          icon: "/stu1.svg",
        },
        {
          key: "教师",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 11 },
          icon: "/tea1.svg",
        },
        {
          key: "管理人员",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 12 },
          icon: "/adm1.svg",
        },
        {
          key: "毕业校友",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 13 },
          icon: "/fre1.svg",
        },
      ],
      //点击文章后展示的详细信息
      detailMSG: [
        {
          // ContactPhone: "10000000",
          // BusinessContent: "11月15日下午，……(还有信息，不在文档里展示了) ",
          // BusinessName: "关于开学军训的通知",
          // SubClassName: "军训",
          // BusinessClass: "1001",
          // ClassName: "开学教育",
          // BusinessDepartment: "10",
          // ClassId: "10",
          // BusinessObject: "10",
          // BusinessID: 1001,
          // DepartName: "教务处",
        },
      ],
      //类型一的附件 相关制度ID
      attachment1: [
        // {
        //   AttachmentFileName: "12",   //id
        //   AttachmentID: 1,
        //   AttachmentName: "测试数据", //展示名称
        //   AttachmentType: "1",
        //   BusinessID: "1",
        // },
      ],
      //类型二的附件  相关表格ID
      attachment2: [],
    };
  },
  methods: {
    updateElementPosition() {
      if (window.innerHeight > 1080) {
        this.elementStyle.bottom = '32px';
        this.elementStyle.top = ''; // 清空 top 样式
      } else {
        this.elementStyle.top = '1027px';
        this.elementStyle.bottom = ''; // 清空 bottom 样式
      }
    },
    updateBreadcrumb() {
      this.breadcrumbData[0] = {
        key: this.breadcrumbDataAll[0].key,
        name: this.breadcrumbDataAll[0].name,
        params: this.breadcrumbDataAll[0].params,
        path: this.breadcrumbDataAll[0].path,
        icon: this.breadcrumbDataAll[0].icon,
      };
      this.breadcrumbData[1] = {
        key: this.detailMSG.ObjectName,
        name:
          this.breadcrumbDataAll.find(
            (item) => item.key === this.detailMSG.ObjectName
          )?.name || "", // Fallback to an empty string if not found
        params:
          this.breadcrumbDataAll.find(
            (item) => item.key === this.detailMSG.ObjectName
          )?.params || {},
        path:
          this.breadcrumbDataAll.find(
            (item) => item.key === this.detailMSG.ObjectName
          )?.path || "",
        icon:
          this.breadcrumbDataAll.find(
            (item) => item.key === this.detailMSG.ObjectName
          )?.icon || "",
      };
      this.breadcrumbData[2] = {
        key: this.detailMSG.SubClassName,
        name: "", // Assuming there's no name for this object; adjust as needed
        params: {},
        path: "",
        icon: "",
      };
    },
    haveArticleCTN: function (articleId) {
      searchArticle(articleId).then((result) => {
        this.detailMSG = result[0];
        console.log(this.detailMSG);
        this.updateBreadcrumb();
        this.dealMSG(result);
      });
    },
    dealMSG(totalData) {
      this.attachment1 = [];
      this.attachment2 = [];
      for (let i = 1; i < totalData.length; i++) {
        if (totalData[i].AttachmentType == 0) {
          this.attachment1.push(totalData[i]);
        } else {
          this.attachment2.push(totalData[i]);
        }
      }
      console.log(this.attachment1);
      console.log(this.attachment2);
      if (this.attachment1.length >= 1) {
        this.showAppend = true;
      } else {
        this.showAppend = false;
      }
      if (this.attachment2.length >= 1) {
        this.showChart = true;
      } else {
        this.showChart = false;
      }

      if (this.attachment1.length == 0 && this.attachment2.length == 0) {
        this.showAppendBox = false;
      } else {
        this.showAppendBox = true;
      }
    },
    returnHome() {
      this.$router.push("./pc_home");
    },
    returnObj: function () {
      if (this.searchCTN) {
        this.$router.push({
          path: "./pc_search",
          name: "pc_search",
          params: {
            msg: this.searchCTN,
          },
        });
      } else {
        console.log("返回到Obj");
        console.log(this.objId);
        switch (this.objId.toString()) {
          case "10":
            this.$router.replace({
              path: "./pc_obj",
              name: "pc_obj",
              params: {
                msg: 10,
              },
            });
            break;
          case "11":
            this.$router.push({
              path: "./pc_obj",
              name: "pc_obj",
              params: {
                msg: 11,
              },
            });
            break;
          case "12":
            this.$router.push({
              path: "./pc_obj",
              name: "pc_obj",
              params: {
                msg: 12,
              },
            });
            break;
          case "13":
            this.$router.push({
              path: "./pc_obj",
              name: "pc_obj",
              params: {
                msg: 13,
              },
            });
            break;
        }
      }
    },
    download(name) {
      console.log(name);
      this.theHref = "https://jwgf.henu.edu.cn:443/attachment/download/" + name;
      axios({
        method: "post",
        url: "https://jwgf.henu.edu.cn:443/attachment/download/" + name,
        responseType: "blob",
      }).then((res) => {
        console.log(res.data);
        this.toDownload(res.data);
      });
    },
    toDownload(data) {
      if (!data) {
        return;
      }

      if (confirm("是否下载此附件")) {
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", this.theHref);
        document.body.appendChild(link);
        link.click();
      }
    },
    //获取文件
    getFile: function (articleID) {
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" +
          articleID,
      }).then((res) => {
        console.log(res.data);
        this.detailMSG = res.data;
        this.dealMSG(res.data);
      });
    },
  },
};
</script>